<template>
  <div>
    <v-autocomplete
      background-color="white"
      hide-details
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="ListaEstado"
      item-text="descripcion_motivo"
      item-value="id_motivo"
      label="Motivo"
      persistent-hint
      return-object
      @change="$emit('input', select.id_motivo)"
    ></v-autocomplete>
    <v-text-field
      hide-details
      outlined
      dense
      label="Motivo"
      v-if="readonly === true"
      filled
      readonly
      :value="select.descripcion_motivo"
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    value: Number,
    id_estado: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      select: {
        id_motivo: 0,
        descripcion_motivo: '',
      },
      ListaEstado: [],
    }
  },
  computed: {
    ...mapState('motivos', ['Lista']),
  },
  methods: {
    seleccionar(id) {
      let pr = null
      if (this.ListaEstado.length > 0) {
        if (id != undefined) {
          if (id != 0) {
            pr = this.ListaEstado.find((x) => x.id_motivo == id)
          }
        }
        if (pr != null) {
          this.select = pr
        } else {
          // this.seleccionar("0");
          this.select = this.ListaEstado[0]
          this.$emit('input', this.select.id_motivo)
        }
      }
    },
  },

  async mounted() {
    let id = this.value
    this.seleccionar(id)
    if (this.id_estado) {
      this.ListaEstado = this.Lista.filter((x) => x.id_estado == this.id_estado)
    } else {
      this.ListaEstado = this.Lista
    }
    if (this.value) {
      this.seleccionar(this.value)
    }
  },
  watch: {
    value() {
      this.seleccionar(this.value)
    },
    id_estado() {
      this.ListaEstado = this.Lista.filter((x) => x.id_estado == this.id_estado)
      if (this.value) {
        this.seleccionar(this.value)
      }
    },
  },
}
</script>

<style></style>
